import { processStory } from "@/utils/utils";
import answerNumStory2 from "./115.txt";

export function upgradeCyoV1ToV2(cyoV1) {
  if (cyoV1.initialDesktopState.version !== 1 || cyoV1.id !== "cya") {
    return cyoV1;
  }
  try {
    return {
      ...cyoV1,
      initialEdState: {
        ...cyoV1.initialEdState,
        files: {
          ...cyoV1.initialEdState.files,
          "fences.txt": chain(cyoV1.initialEdState.files["fences.txt"], [
            replaceNthMatchingLine("-- FENCES BEGIN --", 2, "-- FENCES END --"),
            replaceSection([
              "When you are done, run `w` to write the file. This will give you the",
              "number of bytes written. You can use that number to find the next file,",
              "which will be that number with a txt extension. So if `w` gives you the",
              "number 4253, you will run `e 4253.txt`."
            ], [
              "When you are done, run `w` to write the file. Then run `!chkfnc` to",
              "check your work and continue."
            ]),
            removeDoubleLastNewLine
          ]),
          "2245.txt": removeDoubleLastNewLine(processStory(answerNumStory2))
        }
      },
      initialDesktopState: {
        ...cyoV1.initialDesktopState,
        help: chain(cyoV1.initialDesktopState.help, [
          addLines([
            "BUGS",
            "",
            "If you encounter an issue where the length of the code fences is not",
            "correct upon writing, run !chkfnc to progress instead."
          ])
        ])
      }
    };
  } catch (e) {
    console.error("Error upgrading cyo v1 to v2", e);
    return cyoV1;
  }
}

function chain(text, operations) {
  return operations.reduce((acc, operation) => operation(acc), text);
}

function replaceNthMatchingLine(search, n, replacement) {
  return (text) => {
    const lines = text.split("\n");
    let count = 0;
    const newLines = lines.map((line) => {
      if (line.includes(search)) {
        count++;
        if (count === n) {
          return replacement;
        }
      }
      return line;
    });
    return newLines.join("\n");
  }
}

function replaceSection(search, replacement) {
  return (text) => {
    const lines = text.split("\n");
    let firstMatchingLine = lines.indexOf(search[0]);
    let lastMatchingLine = lines.indexOf(search[search.length - 1]);
    if (firstMatchingLine === -1 || lastMatchingLine === -1) {
      return text;
    }
    const newLines = lines.slice(0, firstMatchingLine)
      .concat(replacement)
      .concat(lines.slice(lastMatchingLine + 1));
    return newLines.join("\n");
  }
}

function removeDoubleLastNewLine(text) {
  return text.replace(/\n\n$/, "\n");
}

function addLines(lines) {
  return (text) => {
    const newLines = text.split("\n").concat(lines);
    return newLines.join("\n") + "\n";
  }
}
